import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { MaterialUsagePage } from '../../features/material-usage/material-usage-page';

export const Route = createFileRoute('/materials/usage')({
  staticData: {
    breadcrumb: 'Usage',
    // The usage filters name a partner's factory and product, so they can't
    // survive a partner switch — see the flag's docs in router-types.d.ts.
    resetSearchOnPartnerChange: true,
  },
  component: MaterialUsageRoute,
});

function MaterialUsageRoute() {
  const { t } = useTranslation('materials');
  const enabled = useFeatureFlag('bill_of_materials');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">{t('notEnabled.title')}</h2>
        <p className="text-muted-foreground text-sm">{t('notEnabled.body')}</p>
      </div>
    );
  }

  return <MaterialUsagePage partnerId={partnerId} />;
}
